import React, { useEffect, useState } from 'react';
import { LABLES } from "../../../shared/constants/data";
import ROUTES from "../../../shared/constants/routes";
import { getData, setData } from '../../../shared/utils/storage.util'
import { useHistory } from "react-router-dom";
import { msalInstance } from '../../../shared/config/msalConfig';

const HeaderComponent = () => {

  const history = useHistory();
  const [userName, setUserName] = useState('');
  const [userRole, setUserole] = useState('');
  const [open, setOpen] = useState(false);
  let [wrapperRef, setWrapperRefData] = useState(null)

  useEffect(() => {
    setUserName(getData('loginData')?.userData.first_name + ' ' + getData('loginData')?.userData.last_name);
    setUserole(getData('loginData')?.userData.role_name);
    setData('loggedUser', userName);
    setData('loggedUserRole', userRole)
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  });

  const setWrapperRef = (ref) => {
    wrapperRef = ref;
  }

  const handleClickOutside = (event) => {
    if (wrapperRef && !wrapperRef.contains(event.target)) {
      setOpen(false)
    }
  }

  const logout = async (evt) => {
    evt.preventDefault();
    localStorage.removeItem('adminData');
    try {
      await msalInstance.logoutPopup();
    } catch (e) {
      // If MSAL logout fails, still proceed with local logout
    }
    history.push(ROUTES.LANDING);
  }

  const goToHome = (event) => {
    event.preventDefault();
    history.push(ROUTES.DASHBOARD);
  }

  return (
    <header>
      <div className="login-header">
        <a href="" className="brand-logo" onClick={goToHome}>
          <img src={require("../../../assets/images/niagara-logo-color-2-x.png")} alt="" />
        </a>
        <div className="user-info" onClick={() => setOpen(!open)} open={open} ref={setWrapperRef}>
          <div>
            {userName}<br />
            <span>{userRole}</span>
          </div>
          {(open) ?
            <ul>
              <li><a href="" onClick={(evt) => logout(evt)}>{LABLES.LogOut}</a></li>
            </ul> : null
          }
        </div>
      </div>
    </header>
  )
}

export default HeaderComponent;
